import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `ResourcesDirective` represent a resource of the react Schedule.
 * It must be contained in a Schedule component(`SchduleComponent`).
 * ```tsx
 * <ScheduleComponent>
 * <ResourcesDirective>
 * <ResourceDirective field='RoomId' name='Rooms'></ResourceDirective>
 * <ResourceDirective field='OwnerId' name='Owners'></ResourceDirective>
 * <ResourcesDirective>
 * </ScheduleComponent>
 * ```
 */
export class ResourceDirective extends ComplexBase {
}
ResourceDirective.moduleName = 'resource';
export class ResourcesDirective extends ComplexBase {
}
ResourcesDirective.propertyName = 'resources';
ResourcesDirective.moduleName = 'resources';
